import { vShow as _vShow, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6cfa9178"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Response:", -1))
const _hoisted_3 = {
  ref: "playingAnimation",
  class: "lottie-container2"
}
const _hoisted_4 = {
  key: 0,
  class: "recording-timer"
}
const _hoisted_5 = { style: {"color":"blueviolet"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question) = $event)),
        placeholder: "Hangi doktorlar ile çalışıyorsunuz?",
        style: {"width":"80%"}
      }, null, 512), [
        [_vShow, false],
        [_vModelText, _ctx.question]
      ])
    ]),
    (1 > 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("p", null, _toDisplayString(_ctx.responseText), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("div", {
        ref: "initialAnimation",
        class: "lottie-container",
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startRecording && _ctx.startRecording(...args))),
        onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args))),
        onTouchstart: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startRecording && _ctx.startRecording(...args))),
        onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopRecording && _ctx.stopRecording(...args)))
      }, null, 544), [
        [_vShow, !_ctx.isPlaying]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _ctx.isPlaying]
      ]),
      (_ctx.isRecording)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.formatTime(_ctx.recordingTime)), 1))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.question), 1)
    ])
  ]))
}